import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGatsbyComponent } from './simple-icons-gatsby.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGatsbyComponent ],
    exports:      [ SimpleIconsGatsbyComponent ],
    bootstrap:    []
})
export class SimpleIconsGatsbyModule {}
